import { ContractTradeType } from "@/types";
import { useTranslation } from "react-i18next";
import ContractTradeTypeEnum from "@/constants/enums/ContractTradeTypeEnum";
import Text from "@/components/atoms/Text";

interface Props {
  contractType: ContractTradeType;
  tradingPartnerCompanyName: string;
  currentCompanyName: string;
  testId?: string;
}

const PriceTextInputLabel = ({ contractType, tradingPartnerCompanyName, currentCompanyName, testId }: Props) => {
  const { t } = useTranslation();
  if (contractType === ContractTradeTypeEnum.BUY) {
    return (
      <Text lineClamp={1} data-testid={testId}>{`${t("contracts:priceToSeller")} (${tradingPartnerCompanyName})`}</Text>
    );
  } else {
    return <Text lineClamp={1} data-testid={testId}>{`${t("contracts:priceToSeller")} (${currentCompanyName})`}</Text>;
  }
};

export default PriceTextInputLabel;
